import { useEffect, useState } from "react";
import { InputMoney } from "../../../../../theme/Input/InputMoney";

interface Props {
    item: any;
    onChange: any;
}
export const ConcepItem = ({ item, onChange }: Props) => {

    const [element, setElement] = useState<any>({});
    useEffect(() => {
        setElement(item);
    }, [item])
    useEffect(() => {
        onChange(element);
    }, [element.Value])



    return (

        <div className="col-md-6">
            <label id={item.Type}><strong>{item.Name}</strong></label>
            <InputMoney _label="" _value={item.Value ?? 0} onChange={(e) => { setElement({ ...element, "Value": e }) }} />
            <small>{item.TypeName}</small>
        </div>

    )
}